import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./UserForm.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import Form from '/src/components/form/Form';
import { useNavigate } from "react-router-dom";

import Dropdown from '/src/components/UI/DropDown/DropDown';
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import TextInput from '/src/components/UI/TextField/TextInput';
import IconsChannels from '../../../../phone/data/types/Icons';
import Field from '/src/components/UI/Field/Field';
import Storage from "/src/utils/storage";
import Button from "/src/components/UI/Button/Button";
import ChooseFile from "/src/components/UI/ChooseFile/ChooseFile";

import { useForm } from 'react-hook-form';

import "/src/assets/css/polices.css"
import "./UserForm.css"
import companyService from "/src/features/administration/company/services/companyService";

import Slider, { Slide, ScrollIntoSlide } from '/src/components/slider/sliderView';
import userService from "../../services/userService";
import roleService from "../../../role/services/roleService";
import datasetService from '/src/features/dataset/services/datasetService';
import dashboardService from "/src/features/plugins/dashboard/services/dashboardService";
import channelService from "/src/features/plugins/channels/services/channelService";
import UserFormType from "./UserFormType";
import imageChoices from "../../../role/components/RoleForm/roleImages";
import roleAdmin from '../../../role/assets/role-superadmin.png';
import roleUser from '../../../role/assets/role-partners.png';
import generateKey from '/src/utils/generateKey';

function UserForm({ data, type }) {
    const currentUser = Storage('local').get('user');
    const navigate = useNavigate();
    const authorizations = data ? JSON.parse(data.authorizations) : null;
    const { register, handleSubmit, formState: { errors }, formState, getValues, setValue, watch } = useForm({
        mode: "onChange",
        defaultValues: {
            id: data ? data.id : "",
            username: data ? data.username : "",
            email: data ? data.email : "",
            //company_id: data ? data.company?.id : "",
            companies: data ? data.companies : "",
            image: data ? data.picture : "", // form.statementArray,
            //company_role: data ? data.company_role : undefined,
            global_role: data ? (data?.is_admin ? 1 : 2) : 2,
            companies_roles: data ? authorizations?.companies_roles : undefined
        },
    });
    const dataType = UserFormType[type ? type : "create"];
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const { getCompaniesAutocomplete, getCompanies } = companyService;
    const { addUser, updateUser, checkAvaibility } = userService;
    const { getDashboards, getDashboardsShared } = dashboardService;
    const { getChannels } = channelService
    const [listCheckedCompanies, setListCheckedCompanies] = useState([]);
    const [listCheckedDatasets, setListCheckedDatasets] = useState(authorizations?.datasets_ids ?? []);
    const [listCheckedDashboards, setListCheckedDashboards] = useState(authorizations?.dashboards_ids ?? []);
    const [listCheckedChannels, setListCheckedChannels] = useState(authorizations?.channels_ids ?? []);

    const { getRoles, getRolesFilter } = roleService;
    const [roles, setRoles] = useState([]);
    const [companies, setCompanies] = useState([])
    const [datasets, setDatasets] = useState([])
    const [dashboards, setDashboards] = useState([])
    const [channels, setChannels] = useState([])

    const [rolesCompany, setRolesCompany] = useState([{ value: 'undefined', text: 'Choose Role' }]);

    const [userAvailable, setUserAvailable] = useState({ email: true, username: true });
    const [file, setFile] = useState(data?.picture);
    const [loadAnim, setLoading] = useState(null);
    //const [dataReady, setDataReady] = useState(false);
    const [showRoleCompanyField, setShowRoleCompanyField] = useState(data ? !data.is_admin : false);
    const { getDatasets } = datasetService;

    const onSubmit = async () => {
        var dataToSend = getValues();
        dataToSend.companies_ids = listCheckedCompanies
        dataToSend.datasets_ids = listCheckedDatasets
        dataToSend.dashboards_ids = listCheckedDashboards
        dataToSend.channels_ids = listCheckedChannels
        //console.log(dataToSend);
        dataToSend.companies_roles = dataToSend.companies_roles?.filter(item =>
            item.roleId !== "undefined" &&
            listCheckedCompanies.includes(parseInt(item.id))
        ) ?? [];

        const formData = new FormData();
        formData.append('username', dataToSend.username)
        formData.append('email', dataToSend.email)
        //formData.append('company_id', dataToSend.company_id)
        formData.append('companies_ids', JSON.stringify(dataToSend.companies_ids))
        formData.append('datasets_ids', JSON.stringify(dataToSend.datasets_ids))
        formData.append('dashboards_ids', JSON.stringify(dataToSend.dashboards_ids))
        formData.append('channels_ids', JSON.stringify(dataToSend.channels_ids))
        formData.append('companies_roles', JSON.stringify(dataToSend.companies_roles))
        //formData.append('company_role', dataToSend.company_role)
        formData.append('global_role', parseInt(dataToSend.global_role))
        formData.append('image', file)

        let [response, error] = data != null ? await updateUser(data.id, formData) : await addUser(formData)
        if (error !== null) {
            console.log(error);
            return;
        }
        //console.log(response);  
        let searchUrl = location.pathname.substring(0, location.pathname.lastIndexOf('/'));;
        return navigate(searchUrl + "/list")

    };

    const showImage = (role) => {
        if (role.id === 1) {
            return <img src={roleAdmin} alt="Role Admin" />;
        } else if (role.id === 2) {
            return <img src={roleUser} alt="Role User" />;
        } else {
            const logoChoice = imageChoices.find(choice => choice.value === role.logo);
            if (logoChoice) {
                return <img src={logoChoice.text.props.src} alt={logoChoice.text.props.alt} />;
            } else {
                return <img src={role.avatar} width={24} height={24} alt={role.avatar} />;
            }
        }
    };

    const setUpRoles = (_roles) => {
        const roles = _roles || [];
        roles.sort((a, b) => b.id - a.id);
        return roles.map(role => ({
            value: role.id,
            text:
                <span style={{ maxWidth: "300px", textAlign: 'center' }}>
                    <div className="roles_content_dropdown"> {showImage(role)} {role.id == 1 ? "Super admin" : role.slug}</div>
                </span>
        }))

    }

    const setUpRolesCompany = (_roles) => {
        const _rolesCompany = _roles || [];
        const initialOption = { value: 'undefined', text: 'Choose Role' };
        return _rolesCompany.map(({ companyId, company, roles }) => ({
            company_id: companyId,
            company_name: company?.name || '—',
            html: [
                initialOption,
                ...roles.map(role => ({
                    value: role.id,
                    text: (
                        <span style={{ maxWidth: "300px", textAlign: "center" }}>
                            <div className="roles_content_dropdown"> {showImage(role)} {role.slug}</div>
                        </span>
                    )
                }))
            ]
        }));

    }

    const getRolesByUser = async () => {
        let [response, error] = await getRolesFilter({ company_id: null });
        if (error !== null) {
            console.log(error);
            return;
        }
        setRoles(setUpRoles(response));
    }

    const getDatasetsInCompanies = async (companies_ids) => {
        //let companies_ids = _companies.map(comp => comp.id);
        companies_ids = companies_ids.length == 0 ? null : companies_ids;
        let [response, error] = await getDatasets(companies_ids);
        if (error !== null) {
            console.log(error);
            return;
        }
        setDatasets(response);

        let d = listCheckedDatasets ?? [];
        let filteredDatasets = d.filter(ds => response.some(r => r.id === ds));
        setListCheckedDatasets([...filteredDatasets]);
    }

    const getDashboardsInCompanies = async (companies_ids) => {
        //let companies_ids = _companies.map(comp => comp.id);
        companies_ids = companies_ids.length == 0 ? null : companies_ids;
        let [response1, error1] = await getDashboards({ companies_ids: companies_ids });
        if (error1 !== null) {
            console.log(error1);
            return;
        }

        let [response2, error2] = await getDashboardsShared({ companies_ids: companies_ids });
        if (error2 !== null) {
            console.log(error2);
            return;
        }
        let merged = [...response1, ...response2];
        let uniqueById = Array.from(new Map(merged.map(item => [item.id, item])).values());


        let d = listCheckedDashboards ?? [];
        let filteredDashboards = d.filter(ds => merged.some(r => r.id === ds));

        setDashboards(uniqueById);
        setListCheckedDashboards([...filteredDashboards])
    }
    const getRolesByUserInCompanies = async (companies_ids) => {
        let [response, error] = await getRoles({ companies_ids: companies_ids });
        if (error !== null) {
            console.log(error);
            return;
        }
        let groupedRoles = {};
        response.forEach(role => {
            if (role.company_id == null) return;
            let companyId = role.company_id;
            if (!groupedRoles[companyId]) {
                groupedRoles[companyId] = [];
            }
            groupedRoles[companyId].push(role);
        });
        let groupedRolesArray = Object.entries(groupedRoles)
            .map(([companyId, roles]) => ({
                companyId,
                company: roles[0]?.company,
                roles
            }))
            .sort((a, b) => {
                let nameA = a.company?.name?.toLowerCase() || "";
                let nameB = b.company?.name?.toLowerCase() || "";
                return nameA.localeCompare(nameB);
            });

        setRolesCompany(setUpRolesCompany(groupedRolesArray));
    };

    const getChannelsInCompanies = async (companies_ids) => {
        //let companies_ids = _companies.map(comp => comp.id);
        companies_ids = companies_ids.length == 0 ? null : companies_ids;
        let [response, error] = await getChannels({ companies_ids: companies_ids });
        if (error !== null) {
            console.log(error);
            return;
        }
        setChannels(response);

        let c = listCheckedChannels ?? [];
        let filteredChannels = c.filter(ch => response.some(r => r.id === ch));
        setListCheckedChannels([...filteredChannels])

    }
    const checkValues = async (title, value) => {
        let dataToSend = [];
        dataToSend[title] = value;
        if (value.length == 0) return;
        let [response, error] = await checkAvaibility(dataToSend)
        if (error !== null) {
            console.log(error);
            return;
        }
        let res = userAvailable;
        res[title] = title == "email" && value.match(emailRegex) === null ? false : response.available
        if (data != null && value === data[title]) {
            res[title] = true
        }
        setUserAvailable({ ...res })
    }

    useEffect(() => {
        setShowRoleCompanyField(watch('global_role') !== 1);
    }, [watch('global_role')]);


    useEffect(() => {
        getAllCompanies();
        getRolesByUser();
    }, []);

    var defaultChoiceCompany = 'undefined';
    if (data && data.roles && rolesCompany) {
        const roleId = data.roles.find(role => rolesCompany.some(rc => rc.value === role.id));
        if (roleId) {
            defaultChoiceCompany = roleId.id;
        }
    }


    const getAllCompanies = async () => {
        let [response, error] = await getCompanies()
        if (error !== null) {
            console.log(error);
            return;
        }
        setCompanies(response);
        let r = data ? data.companies : []
        let filtered = r.map(c => c.id);
        setListCheckedCompanies([...filtered]);
        if (filtered != null && filtered.length > 0){
            refreshLists(filtered);
        }
        return r;
    }

    const toggleItemSelection = ({ item, list, setList, type }) => {

        let button = document.getElementById(`${item.id + type}_button`);
        let isAlreadyChecked = list.some((el) => el === item.id);
        let newList = list;
        if (!isAlreadyChecked) {
            newList.push(item.id);
            button.style.color = "var(--green)";
            button.children[0].classList = "fas fa-check-circle";
        } else {
            let index = list.findIndex((el) => el === item.id);
            newList.splice(index, 1)
            button.style.color = "var(--main)";
            button.children[0].classList = "fas fa-plus-circle";
        }

        setList([...newList]);

        if (type === "company") {
            refreshLists(newList);

        }
    };


    const setRolesCompanyValue = (roleId, id) => {
        let currentRoles = getValues("companies_roles") || [];
        let companiesIds = listCheckedCompanies || [];

        const existingIndex = currentRoles.findIndex(item => item.id === id);
        let updatedRoles;
        if (existingIndex !== -1) {
            updatedRoles = currentRoles.map(item => item.id === id ? { id, roleId } : item);
        }
        else {
            updatedRoles = [...currentRoles, { id, roleId }];
        }
        //console.log(updatedRoles);
        updatedRoles = updatedRoles.filter(item => companiesIds.includes(parseInt(item.id)));

        setValue("companies_roles", updatedRoles, {
            shouldValidate: true,
            shouldDirty: true
        });
    };


    const checkCompany = (_company) => {
        toggleItemSelection({ item: _company, list: listCheckedCompanies, setList: setListCheckedCompanies, type: "company" });
    }

    const checkDataset = (_dataset) => {
        toggleItemSelection({ item: _dataset, list: listCheckedDatasets, setList: setListCheckedDatasets, type: "dataset" });
    }
    const checkDashboard = (_dashboard) => {
        toggleItemSelection({ item: _dashboard, list: listCheckedDashboards, setList: setListCheckedDashboards, type: "dashboard" });
    }
    const checkChannel = (_channel) => {
        toggleItemSelection({ item: _channel, list: listCheckedChannels, setList: setListCheckedChannels, type: "analytics" });
    }

    const refreshLists = (_companies) => {
        getDatasetsInCompanies(_companies);
        getDashboardsInCompanies(_companies);
        getChannelsInCompanies(_companies);
        getRolesByUserInCompanies(_companies)
    }
    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Title>{dataType.title}</Form.Title>
            <Form.Body className="user_form_body">
                <Slider >

                    <Slide name="main_form" className={"slide_user_form"}>

                        <div className="container_line_dropdown_form_user">
                            <Field label="Global role" listLabelClassName="titles-input" />
                            <div>
                                {(roles != null && roles.length > 0) &&
                                    <Dropdown name="global_role"  {...register('global_role')} setValue={(_n, value) => { setValue('global_role', value) }} choices={roles} defaultChoice={data ? (data?.is_admin ? 1 : 2) : 2} width="240px" />
                                }
                            </div>
                        </div>
                        <br></br>
                        <div style={{ marginBottom: "15px" }}>
                            <Field label="Username" />
                            <TextInput {...register('username', { required: true, minLength: 1, onChange: (e) => checkValues("username", e.target.value) })} style={{ borderColor: userAvailable.username == false ? 'red' : "" }} className="full-width text_input_user_form" defaultValue={data ? data.username : ""} placeholder="Choose your username" />
                        </div>
                        <br></br>
                        <div style={{ marginBottom: "15px" }}>
                            <Field label="Email" />
                            <TextInput {...register('email', { required: true, minLength: 1, onChange: (e) => checkValues("email", e.target.value) })} style={{ borderColor: userAvailable.email == false ? 'red' : "" }} className="full-width text_input_user_form" defaultValue={data ? data.email : ""} placeholder="Choose your email" />
                        </div>
                        <br></br>
                        <div>
                            <Field label="Avatar" />
                            <ChooseFile _setFile={setFile} defaultValueImage={data?.picture} accept=".png,.jpg,.jpeg" loadAnim={loadAnim} colorBorder={"inset 0 0 0 1px #dddddd;"}></ChooseFile>
                        </div>

                        { watch("global_role") != 1 && 
                        <div className="user_form_advanced_parameters" onClick={() => ScrollIntoSlide("company_section")}> Select Companies <i className="fas fa-arrow-right" style={{ marginLeft: "5px", marginTop: "25px" }}></i></div>
                        }
                        </Slide>
                    {
                        watch("global_role") != 1 &&
                        <>
                            <Slide name="company_section" className={"slide_dashboard_form_channel"}>
                                <br />



                                <div style={{ height: "70%" }}>
                                    <Field label={"Organizations (" + listCheckedCompanies.length + "/" + companies.length + ")"} listLabelClassName="titles-input" />
                                    <div className={"user_list_companies"}>
                                        {companies.map((company, i) => {
                                            let bool = listCheckedCompanies.length > 0 ? listCheckedCompanies.some(comp => comp == company.id) : (data ? data.companies.some(comp => comp == company.id) : false);
                                            //let bool = listCheckedChannel.includes(_channel.id)
                                            return (
                                                <div className="project-block" data-checked="false" data-id={company.id} key={generateKey()} style={{ border: bool ? "2px solid var(--main)" : "" }}>
                                                    <div style={{ alignItems: "center", display: "flex" }}>
                                                        <i style={{ marginRight: '15px', fontSize: "20px" }}></i>
                                                        {company.name}
                                                    </div>
                                                    <div>
                                                        <IconButton id={company.id + "company_button"} className="main-iconButton add-hover modalButtons-input" icon={bool ? "fas fa-check-circle" : "fas fa-plus-circle"} onClick={(e) => checkCompany(company)} style={{ color: bool ? "var(--green)" : "var(--main)" }} />

                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>

                                <br />

                                <div style={{ display: "flex", justifyContent: "space-between", width: "90%" }}>
                                    <div className="user_form_advanced_parameters" onClick={() => ScrollIntoSlide("main_form")}> <i className="fas fa-arrow-left" style={{ marginRight: "10px", marginTop: "25px" }}></i>Main parameters</div>

                                    {listCheckedCompanies.length > 0 &&
                                        <div className="user_form_advanced_parameters" onClick={() => ScrollIntoSlide("roles_in_companies")}>Roles <i className="fas fa-arrow-right" style={{ marginLeft: "5px", marginTop: "25px" }}></i></div>
                                    }
                                </div>
                            </Slide>

                            <Slide name="roles_in_companies">
                                <br />
                                <div style={{ height: listCheckedCompanies.length == 0 ? "50%" : "70%" }}>
                                    <Field label={"Roles by Organization"} listLabelClassName="titles-input" />
                                    {rolesCompany && Array.isArray(rolesCompany) && rolesCompany.map((group, index) => {
                                        if (group.value == "undefined") return;
                                        let roleId = authorizations?.companies_roles?.find(r => r.id === group.company_id)?.roleId;
                                        return (
                                            <div key={group.company_id} className="container_line_dropdown_form_user" style={{ width: "45%", marginBottom: "40px" }}>
                                                <label className="titles-input" style={{ color: "var(--main)" }}>{group.company_name}</label>
                                                <Dropdown name={`company_role_${group.company_id}`} setValue={(name, value) => setRolesCompanyValue(value, group.company_id)} {...register(`company_role_${group.company_id}`)} choices={group.html} defaultChoice={roleId ?? defaultChoiceCompany} width="235px" />
                                            </div>

                                        )
                                    })}
                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between", width: "90%" }}>
                                    <div className="user_form_advanced_parameters" onClick={() => ScrollIntoSlide("company_section")}> <i className="fas fa-arrow-left" style={{ marginRight: "10px", marginTop: "25px" }}></i>Main parameters</div>
                                    <div className="user_form_advanced_parameters" onClick={() => ScrollIntoSlide("shared_elements")}>Shared elements <i className="fas fa-arrow-right" style={{ marginLeft: "5px", marginTop: "25px" }}></i></div>

                                </div>
                            </Slide>

                            <Slide name="shared_elements" className={"shared_elements"}>
                                <br />
                                <div style={{ height: listCheckedCompanies.length == 0 ? "50%" : "70%" }}>
                                    <Field label={"Datasets (" + listCheckedDatasets.length + "/" + datasets.length + ")"} listLabelClassName="titles-input" />
                                    <div className={"dataset_list_companies"}>
                                        {datasets.map((dataset, i) => {
                                            let bool = listCheckedDatasets.length > 0 ? listCheckedDatasets.some(d => d == dataset.id) : (data ? authorizations?.datasets_ids?.some(d => d == dataset.id) : false);
                                            //let bool = listCheckedChannel.includes(_channel.id)
                                            return (
                                                <div className="project-block" data-checked="false" data-id={"dataset-" + dataset.id} key={generateKey()} style={{ border: bool ? "2px solid var(--main)" : "" }}>
                                                    <div style={{ alignItems: "center", display: "flex" }}>
                                                        <i className="fas fa-database iconListUserForm"></i>
                                                        {dataset.company.name} - {dataset.name}
                                                    </div>
                                                    <div>
                                                        <IconButton id={dataset.id + "dataset_button"} className="main-iconButton add-hover modalButtons-input" icon={bool ? "fas fa-check-circle" : "fas fa-plus-circle"} onClick={(e) => checkDataset(dataset)} style={{ color: bool ? "var(--green)" : "var(--main)" }} />

                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                                <br></br>
                                <div style={{ height: listCheckedCompanies.length == 0 ? "50%" : "70%" }}>
                                    <Field label={"Dashboards (" + listCheckedDashboards.length + "/" + dashboards.length + ")"} listLabelClassName="titles-input" />
                                    <div className={"dashboard_list_company_form_user"}>
                                        {dashboards.map((dashboard, i) => {
                                            let bool = listCheckedDashboards.length > 0 ? listCheckedDashboards.some(d => d == dashboard.id) : (data ? authorizations?.dashboards_ids?.some(d => d == dashboard.id) : false);
                                            let isShared = dashboard.origin == 0;
                                            //let bool = listCheckedChannel.includes(_channel.id)
                                            return (
                                                <div className="project-block" data-checked="false" data-id={"dashboard-" + dashboard.id} key={generateKey()} style={{ border: bool ? "2px solid var(--main)" : "" }}>
                                                    <div style={{ alignItems: "center", display: "flex" }}>
                                                        <i className={"iconListUserForm " + (isShared ? "fas fa-link" : "fas fa-tachometer-alt")} title={isShared ? "Shared dashboard" : "Main dashboard"}></i>
                                                        <div><span style={{ fontSize: isShared ? "14px" : "" }}>{dashboard.dashboard.company.name + (isShared ? " -> " + dashboard.company.name : "")}</span> - <span style={{ color: "var(--main)" }}>{(dashboard.name != "" && dashboard.name != null) ? dashboard.name : dashboard.dashboard.name}</span></div>
                                                    </div>
                                                    <div>
                                                        <IconButton id={dashboard.id + "dashboard_button"} className="main-iconButton add-hover modalButtons-input" icon={bool ? "fas fa-check-circle" : "fas fa-plus-circle"} onClick={(e) => checkDashboard(dashboard)} style={{ color: bool ? "var(--green)" : "var(--main)" }} />

                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between", width: "90%" }}>
                                    <div className="user_form_advanced_parameters" onClick={() => ScrollIntoSlide("roles_in_companies")}> <i className="fas fa-arrow-left" style={{ marginRight: "10px", marginTop: "25px" }}></i>Roles</div>

                                    <div className="user_form_advanced_parameters" onClick={() => ScrollIntoSlide("analytics_section")}>Analytics <i className="fas fa-arrow-right" style={{ marginLeft: "5px", marginTop: "25px" }}></i></div>

                                </div>
                            </Slide>

                            <Slide name="analytics_section" className={"analytics_section"}>
                                <br />
                                <div style={{ height: "85%" }}>
                                    <Field label={"Analytics : Channels access (" + listCheckedChannels.length + "/" + channels.length + ")"} listLabelClassName="titles-input" />
                                    <div className={"user_analytics_list"}>
                                        {channels.map((channel, i) => {
                                            let bool = listCheckedChannels.length > 0 ? listCheckedChannels.some(ch => ch == channel.id) : (data ? authorizations?.channels_ids?.some(c => c == channel.id) : false);

                                            //let bool = listCheckedChannel.includes(_channel.id)
                                            return (
                                                <div className="project-block" data-checked="false" data-id={"channel-" + channel.id} key={generateKey()} style={{ border: bool ? "2px solid var(--main)" : "" }}>
                                                    <div style={{ alignItems: "center", display: "flex" }}>
                                                        <i className="iconListUserForm fas fa-chart-line"></i>
                                                        {channel.bot.company.name} - {channel.name}
                                                    </div>
                                                    <div>
                                                        <IconButton id={channel.id + "analytics_button"} className="main-iconButton add-hover modalButtons-input" icon={bool ? "fas fa-check-circle" : "fas fa-plus-circle"} onClick={(e) => checkChannel(channel)} style={{ color: bool ? "var(--green)" : "var(--main)" }} />

                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                                <div className="user_form_advanced_parameters" onClick={() => ScrollIntoSlide("shared_elements")}> <i className="fas fa-arrow-left" style={{ marginRight: "10px", marginTop: "25px" }}></i> Shared elements</div>

                            </Slide>
                        </>}
                </Slider >
            </Form.Body >
            <Form.Buttons>

                <Button type="submit" label={dataType.send} className="validate" disabled={!formState.isValid || !file} />
            </Form.Buttons>
        </Form >

    );
}

export default UserForm;